import React from "react";
import SectionCommonTable from "../../components/SectionCommonTable";
import MatchingBonusTable from "./Table/matchingBonusTable";
const MatchingBonusPage = () => {
  return (
    <SectionCommonTable
      wrapperClassName="matchingbonus_table"
      cardStyle={{ backgroundColor: "#fff" }}
      sectionTableTitle="Matching Bonus"
      table={<MatchingBonusTable />}
    />
  );
};

export default MatchingBonusPage;
